<template lang="html">
  <div class="data-feeds-health">
    <el-card style="margin-bottom: 12px;">
      <div style="display: flex; align-items: center; gap: 16px;">
        <el-button type="primary" :loading="isLoading" @click="fetchHealth">
          {{ hasLoaded ? '重新整理' : '讀取資料' }}
        </el-button>
        <span v-if="lastCheckedAt" style="font-size: 13px; color: #909399;">
          上次讀取時間：{{ formatTime(lastCheckedAt) }}
        </span>
      </div>
    </el-card>

    <template v-if="hasLoaded">
      <el-card style="margin-bottom: 12px;">
        <div slot="header">雨量網格資料</div>
        <el-table
          :data="rainGrid"
          v-loading="isLoading"
          border
          size="mini"
          stripe
          style="width: 100%;"
        >
          <el-table-column label="專案名稱" prop="projectName" min-width="160" />
          <el-table-column label="最後更新時間" min-width="150">
            <template #default="{ row }">
              {{ formatTime(row.lastTimestamp) }}
            </template>
          </el-table-column>
          <el-table-column label="距今分鐘" min-width="100">
            <template #default="{ row }">
              {{ formatMinutes(row.minutesSince) }}
            </template>
          </el-table-column>
          <el-table-column label="斷更狀態" min-width="100">
            <template #default="{ row }">
              <el-tag :type="row.stale ? 'danger' : 'success'" size="mini">
                {{ row.stale ? '已斷更' : '正常' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="告警狀態" min-width="100">
            <template #default="{ row }">
              <el-tag :type="row.alertActive ? 'warning' : 'info'" size="mini">
                {{ row.alertActive ? '告警中' : '無告警' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card style="margin-bottom: 12px;">
        <div slot="header">多變數偵測資料</div>
        <div style="display: flex; gap: 32px; font-size: 14px; color: #606266;">
          <span>最後更新時間：{{ formatTime(alarms.lastTimestamp) }}</span>
          <span>距今分鐘：{{ formatMinutes(alarms.minutesSinceUpdate) }}</span>
          <span>最後探測站：{{ alarms.lastProbeName || '-' }}</span>
        </div>
      </el-card>

      <el-card>
        <div slot="header">CCTV模型狀態</div>
        <el-table
          :data="cctvModels"
          v-loading="isLoading"
          border
          size="mini"
          stripe
          style="width: 100%;"
        >
          <el-table-column label="模型名稱" prop="modelName" min-width="160" />
          <el-table-column label="最後運作時間" min-width="150">
            <template #default="{ row }">
              {{ formatTime(row.lastRunTime) }}
            </template>
          </el-table-column>
          <el-table-column label="距今分鐘" min-width="100">
            <template #default="{ row }">
              {{ formatMinutes(minutesSince(row.lastRunTime)) }}
            </template>
          </el-table-column>
          <el-table-column label="狀態" min-width="100">
            <template #default="{ row }">
              <el-tag :type="row.status === 'running' ? 'success' : 'danger'" size="mini">
                {{ row.status === 'running' ? '正常' : (row.status || '未知') }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </div>
</template>

<script>
import moment from 'moment';

const CCTV_MODEL_API_URL = 'https://thsrcctv.com/';

export default {
  name: 'DataFeedsHealth',
  data() {
    return {
      isLoading: false,
      hasLoaded: false,
      lastCheckedAt: null,
      rainGrid: [],
      alarms: {},
      cctvModels: [],
    };
  },
  methods: {
    formatTime(value) {
      if (!value) return '-';
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    formatMinutes(value) {
      if (value === null || value === undefined) return '無資料';
      return value;
    },
    minutesSince(value) {
      if (!value) return null;
      return moment().diff(moment(value), 'minutes');
    },
    fetchDataFeeds() {
      return this.$axios({
        category: 'health',
        method: 'get',
        apiName: 'data-feeds',
      }).then(res => {
        this.rainGrid = res.data.rainGrid || [];
        this.alarms = res.data.alarms || {};
      });
    },
    fetchCctvModelStatus() {
      return this.$axios({
        category: '',
        method: 'get',
        apiName: 'model/status',
        useUrl: CCTV_MODEL_API_URL,
      }).then(res => {
        this.cctvModels = ((res.data.data && res.data.data.items) || []).map(item => ({
          modelName: item.model_name,
          lastRunTime: item.last_run_time,
          status: (item.payload && item.payload.status) || '',
        }));
      });
    },
    fetchHealth() {
      this.isLoading = true;
      return Promise.all([
        this.fetchDataFeeds().catch(this.$notifyError),
        this.fetchCctvModelStatus().catch(this.$notifyError),
      ])
        .then(() => {
          this.hasLoaded = true;
          this.lastCheckedAt = new Date();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
